import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
const iconMap = {
  success: <CheckCircleIcon fontSize="small" />,
  error: <ErrorIcon fontSize="small" />,
  warning: <WarningIcon fontSize="small" />,
  info: <InfoIcon fontSize="small" />,
};

// const iconMap = {
//   success: <i className="fa-sharp fa-regular fa-circle-check" style={{ fontSize: "16px" }}></i>,
//   error: <i className="fa-sharp fa-regular fa-circle-exclamation" style={{ fontSize: "16px" }}></i>,
//   warning: <i className="fa-sharp fa-regular fa-triangle-exclamation" style={{ fontSize: "16px" }}></i>,
//   info: <i className="fa-sharp fa-regular fa-circle-info" style={{ fontSize: "16px" }}></i>,
// };


const colorMap = {
  success: {
    bg: '#B9F6CA', // Light green
    color: '#004D40'
  },
  error: {
    bg: '#FFCDD2', // Light red
    color: '#C62828'
  },
  warning: {
    bg: '#FFF9C4', // Light yellow
    color: '#F57F17'
  },
  info: {
    bg: '#BBDEFB', // Light blue
    color: '#0D47A1'
  },
};

const StyledSnackbar = styled(Snackbar)(() => ({
  zIndex: 25000,
  '& .MuiPaper-root': {
    boxShadow: 'none',
    background: 'transparent',
    padding: 0,
  },
}));

const ToastContainer = styled(Box)(({ bg, color }) => ({
  backgroundColor: bg,
  color: color,
  display: 'flex',
  alignItems: 'center',
  borderRadius: '8px',
  padding: '10px 20px',
  fontSize: '14px',
  fontWeight: 500,
  minWidth: '280px',
  maxWidth: '420px',
  gap: '12px',
}));

const ToastMessage = styled(Typography)({
  flexGrow: 1,
  wordBreak: 'break-word',
  whiteSpace: 'normal',
  overflow: 'visible',
  textOverflow: 'unset',
});

const CustomSnackbar = ({
  open,
  onClose,
  message = 'Toast message',
  severity = 'info',
  autoHideDuration = 4000,
  anchorOrigin = { vertical: 'bottom', horizontal: 'center' },
}) => {
  const { bg, color } = colorMap[severity] || colorMap.info;

  return (
    <StyledSnackbar
      open={open}
      onClose={onClose}
      autoHideDuration={autoHideDuration}
      anchorOrigin={anchorOrigin}
    >
      <ToastContainer bg={bg} color={color}>
        {iconMap[severity]}
        <ToastMessage>{message}</ToastMessage>

        <IconButton
          onClick={onClose}
          size="small"
          sx={{
            color: color,
            padding: 0,
            '&:hover': {
              background: 'rgba(255,255,255,0.15)',
            },
          }}
        >
          {/* <i className="fa-sharp fa-light fa-xmark" style={{ fontSize: "16px" }}></i> */}
          <CloseIcon fontSize="small" />

        </IconButton>
      </ToastContainer>
    </StyledSnackbar>
  );
};

export default CustomSnackbar;
